export class FreeReducedMealAppInfoSharing {
    private static idIncrementor = -1;
    ID: number;
    AppID: number;
    WaiverProgramID: number;
    ProgramName: string;
    ShareWith: string;
    StudentIds: number[];

    constructor() {
        this.ID = FreeReducedMealAppInfoSharing.idIncrementor--;
    }
   }